import React, { useState ,useEffect } from 'react';
import axios from 'axios';
import { Select } from 'antd';

const JobSearch = () => {
const [jobs, setJobs] = useState([]);
 // Fetch jobs from backend when component mounts
 useEffect(() => {
    axios.get('http://localhost:8080/api/user/jobs/all')
      .then(response => {
        setJobs(response.data);
        setFilteredJobs(response.data);
      })
      .catch(error => {
        console.error('Error fetching jobs:', error);
      });
  }, []);

  console.log("jobs"+jobs);

const jobTitles = [...new Set(jobs.map(job => job.jobTitle))];
const skills = [...new Set(jobs.map(job => job.primarySkill))];
const secondaryskills = [...new Set(jobs.map(job => job.secondarySkill))];
const locations = [...new Set(jobs.map(job => job.jobLocation))];
const emails = [...new Set(jobs.map(job => job.pocId))];
const experiences = [...new Set(jobs.map(job => job.experienceRequired))];

  const [filteredJobs, setFilteredJobs] = useState(jobs); // To store filtered jobs
  const [searchCriteria, setSearchCriteria] = useState({
    jobTitle: '',
    primarySkill: '',
    secondarySkill: '',
    jobLocation: '',
    pocId: '',
    jobLink:'',
    experienceRequired: '',
  });
 
  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    const updatedCriteria = {
      ...searchCriteria,
      [name]: value,
    };
    setSearchCriteria(updatedCriteria);
  
    // Auto search on change
    const filtered = jobs.filter((job) => {
      return (
        job.jobTitle.toLowerCase().includes(updatedCriteria.jobTitle.toLowerCase()) &&
        job.primarySkills.toLowerCase().includes(updatedCriteria.primarySkills.toLowerCase()) &&
        job.jobLocation.toLowerCase().includes(updatedCriteria.jobLocation.toLowerCase()) &&
        job.jobDescription.toLowerCase().includes(updatedCriteria.jobDescription.toLowerCase()) &&
        job.secondarySkill.toLowerCase().includes(updatedCriteria.secondarySkill.toLowerCase()) &&
        job.experienceRequired.toLowerCase().includes(updatedCriteria.experienceRequired.toLowerCase()) &&
        job.pocId.toLowerCase().includes(updatedCriteria.pocId?.toLowerCase() || '')
      );
    });
    setFilteredJobs(filtered);
  };

 
  const handleDropdownChange = (name, value) => {
    const updatedCriteria = {
      ...searchCriteria,
      [name]: value || '', // if cleared, set to empty string
    };
    setSearchCriteria(updatedCriteria);
  
    const filtered = jobs.filter((job) => {
      return (
        (updatedCriteria.jobTitle ? job.jobTitle === updatedCriteria.jobTitle : true) &&
        (updatedCriteria.primarySkill ? job.primarySkill === updatedCriteria.primarySkill : true) &&
        (updatedCriteria.secondarySkill ? job.secondarySkill === updatedCriteria.secondarySkill : true) &&
        (updatedCriteria.jobLocation ? job.jobLocation === updatedCriteria.jobLocation : true) &&
        (updatedCriteria.jobDescription ? job.jobDescription === updatedCriteria.jobDescription : true) &&
        (updatedCriteria.pocId ? job.email === updatedCriteria.pocId : true) &&
        (updatedCriteria.experienceRequired ? job.experience === updatedCriteria.experienceRequired : true)
      );
    });
  
    setFilteredJobs(filtered);
  }; 
  

  return (
    <div className="container mx-auto mt-10 p-5  ml-0 min-w-full" >
      <div className="bg-gray-700 text-white px-4 py-3 rounded-t-md" style={{ backgroundColor: '#1f415b' }}>
        <h2 className="text-lg font-semibold" >Job Search</h2>
      </div>
      <br></br>

      {/* Job List */}
      <table className="min-w-full bg-white border border-gray-300">
      <thead>
  <tr className="bg-blue-600">
  <style>
        {`
          .custom-select .ant-select-selection-placeholder {
            color: white !important;
          }
        `}
      </style>
  
    <th className="px-4 py-2 text-left bg-white font-bold" style={{ backgroundColor: '#1f415b' }}>
      <Select
      placeholder="Job Title"
        value={searchCriteria.jobTitle || undefined}
        onChange={(value) => handleDropdownChange('jobTitle', value)}
        allowClear
        className="w-full border-none shadow-none custom-select"
        size="small"
        bordered={false}
        dropdownStyle={{ zIndex: 9999 }}
      >
        {jobTitles.map((title) => (
          <Select.Option key={title} value={title}>
            {title}
          </Select.Option>
        ))}
      </Select>
    </th>

    <th className="px-4 py-2 text-left bg-white " style={{ backgroundColor: '#1f415b' }}><p className="text-grey-100 text-white">Job Description</p></th>
    <th className="px-4 py-2 text-left bg-white font-bold" style={{ backgroundColor: '#1f415b' }}>
      <Select
        placeholder="Primary Skill"
        value={searchCriteria.primarySkill || undefined}
        onChange={(value) => handleDropdownChange('primarySkill', value)}
        allowClear
        className="w-full border-none shadow-none custom-select"
        size="small"
        bordered={false}
        dropdownStyle={{ zIndex: 9999 }}
      >
        {skills.map((primarySkills) => (
          <Select.Option key={primarySkills} value={primarySkills}>
            {primarySkills}
          </Select.Option>
        ))}
      </Select>
    </th>
    <th className="px-4 py-2 text-left bg-white font-bold" style={{ backgroundColor: '#1f415b' }}>
      <Select
        placeholder="Secondary Skill"
        value={searchCriteria.secondarySkill || undefined}
        onChange={(value) => handleDropdownChange('secondarySkill', value)}
        allowClear
        className="w-full border-none shadow-none custom-select"
        size="small"
        bordered={false}
        dropdownStyle={{ zIndex: 9999 }}
      >
        {secondaryskills.map((primarySkills) => (
          <Select.Option key={primarySkills} value={primarySkills}>
            {primarySkills}
          </Select.Option>
        ))}
      </Select>
    </th>
    <th className="px-4 py-2 text-left bg-white font-bold" style={{ backgroundColor: '#1f415b' }}>
      <Select
        placeholder="Location"
        value={searchCriteria.jobLocation || undefined}
        onChange={(value) => handleDropdownChange('jobLocation', value)}
        allowClear
        className="w-full border-none shadow-none custom-select"
        size="small"
        bordered={false}
        dropdownStyle={{ zIndex: 9999 }}
      >
        {locations.map((location) => (
          <Select.Option key={location} value={location}>
            {location}
          </Select.Option>
        ))}
      </Select>
    </th>
    <th className="px-4 py-2 text-left bg-white font-bold" style={{ backgroundColor: '#1f415b' }}>
      <Select
        placeholder="POC Email"
        value={searchCriteria.email || undefined}
        onChange={(value) => handleDropdownChange('email', value)}
        allowClear
        className="w-full border-none shadow-none custom-select"
        size="small"
        bordered={false}
        dropdownStyle={{ zIndex: 9999 }}
      >
        {emails.map((email) => (
          <Select.Option key={email} value={email}>
            {email}
          </Select.Option>
        ))}
      </Select>
    </th>
    <th className="px-4 py-2 text-left bg-white font-bold" style={{ backgroundColor: '#1f415b' }}>
      <Select
        placeholder="Experience"
        value={searchCriteria.experience || undefined}
        onChange={(value) => handleDropdownChange('experience', value)}
        allowClear
        className="w-full border-none shadow-none custom-select"
        size="small"
        bordered={false}
        dropdownStyle={{ zIndex: 9999 }}
      >
        {experiences.map((exp) => (
          <Select.Option key={exp} value={exp}>
            {exp}
          </Select.Option>
        ))}
      </Select>
    </th>
 
    <th className="px-1 py-2 text-left text-white bg-white font-bold" style={{ backgroundColor: '#1f415b' }}>
      Job Link
    </th>
    
  </tr>
</thead>

        <tbody>
          {filteredJobs.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center px-4 py-2 text-gray-500">
                No jobs found.
              </td>
            </tr>
          ) : (
            filteredJobs.map((job) => (
              <tr key={job.id} className="hover:bg-gray-50">
                <td className="border px-4 py-2 text-sm font-medium text-gray-800">{job.jobTitle}</td>
                <td className="border px-4 py-2 text-sm font-medium text-gray-800">{job.jobDescription}</td>
                <td className="border px-4 py-2 text-sm font-medium text-gray-800">{job.primarySkill}</td>
                <td className="border px-4 py-2 text-sm font-medium text-gray-800">{job.secondarySkill}</td>
                <td className="border px-4 py-2 text-sm font-medium text-gray-800">{job.jobLocation}</td>
                <td className="border px-4 py-2 text-sm font-medium text-gray-800">{job.pocId}</td>
                <td className="border px-4 py-2 text-sm font-medium text-gray-800">{job.experienceRequired}</td>
                <td className="border px-4 py-2 text-sm font-medium text-gray-800"><a href={job.jobLink}> Click Here</a></td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default JobSearch;
